;(function ($, window, document, undefined) {
	var $body = $('body'),
	    bodyWidth = $body.innerWidth(),
	    $document = $(document);

	var pluginName = 'beforeAfter',
	    defaults = {
	    	defaultPos: 50,
	    	init: null,//fires after every item in collection is completed
	    	fullInit: null,//fires after all collection is completed
	    	initAnimFinished: null,//fires, when init animation with handle is finised
	    	leftToRightCallback: null,
	    	rightToLeftCallback: null,
	    	synchronized: false
	    };

	function BeforeAfter(element, options, fullCollection) {
		this.element = element;
		this.$element = $(element);
		this.options = $.extend(defaults, options);

		if (this.options.synchronized) {
			this.fullCollection = fullCollection;
		}

		this._defaults = defaults;

		if (this.$element.data('name')) {
			this._name = this.$element.data('name');//для отладки
		} else {
			this._name = pluginName;
		}

		return this.init();
	}

	BeforeAfter.prototype.init = function() {
		var _this = this;

		this.$dragElement = this.$element.find('.ba-handle');
		this.dragElement = this.$dragElement[0];
		this.$resizeLeftElement = this.$element.find('.ba-resize-left');
		this.$resizeRightElement = this.$element.find('.ba-resize-right');
		this.$leftImg = this.$resizeLeftElement.find('img');
		this.$rightImg = this.$resizeRightElement.find('img');
		// this.$resizableImg = this.$element.find('.ba-resizable');

		this.setMetrics();

		// var defPos;

		if (this.overflowed) {
			this.widthValue = (bodyWidth - this.elementOffset) / this.elementWidth * this.options.defaultPos;
		} else {
			this.widthValue = this.options.defaultPos;
		}

		this.setCenterPos();//will be used in recalculations and not only

		this.$dragElement.add(this.$resizeRightElement).add(this.$resizeLeftElement).hide();//is needed, because of browsers don't rerender elements before transition property is added to them
		this.$dragElement.css('left', this.centerPos + '%', 'test');
		this.$resizeLeftElement.css('width', this.centerPos + '%', 'test');
		this.$resizeRightElement.css('width', 100 - this.centerPos + '%', 'test');
		this.$dragElement.add(this.$resizeRightElement).add(this.$resizeLeftElement).show();//is needed, because of browsers don't rerender elements before transition property is added to them

		this.$element.addClass('transitioned visible');

		this.setPos(this.widthValue);

		// Initialize the dragging event on mousedown.
		this.$dragElement.on('mousedown.ba-events touchstart.ba-events', function(e) {
			_this.onMouseDown(e);
		});

		// setTimeout(function() {
			// _this.$dragElement.addClass('animated');
		// }, 200);

		//Recalc of parameters on window resize
		$(window).on('custom.onresize', function() {
			_this.update();
		});

		this.$element.addClass('initialized');
		this.initialized = true;

		if (this.options.init) {
			this.options.init.call(this.$element);
		}

		return this;
	}

	BeforeAfter.prototype.update = function() {
		bodyWidth = $body.innerWidth();
		this.setMetrics();
		var lastCenterPos = this.centerPos;
		this.setCenterPos();
		this.widthValue = this.widthValue * this.centerPos / lastCenterPos;
		this.setPos(this.widthValue);
	}

	BeforeAfter.prototype.setMetrics = function() {

		if (!this.$element.is(':visible')) {//To take correct metrics
			this.$hiddenParent = this.$element.parents().filter(':hidden').last().show();
		} else {
			this.$hiddenParent = null;
		}

		this.elementWidth = this.$element.outerWidth();
		// this.elementInnerWidth = this.$element.innerWidth();
		this.elementOffset = this.$element.offset().left;
		this.dragElementWidth = this.$dragElement.outerWidth();

		this.leftImgWidth = this.$leftImg.width();
		// this.resizableImgWidth = this.$resizableImg.width();

		if (this.$hiddenParent) {
			this.$hiddenParent.hide();
		}

		this.overflowed = (this.elementOffset + this.elementWidth > bodyWidth) ? true : false;
		this.minLeft = this.elementOffset;
		// this.maxLeft = this.elementOffset + this.elementWidth - this.dragElementWidth;
		this.maxLeft = this.elementOffset + this.elementWidth;
		// if(this._name == 'mobile') console.log(this,this.elementWidth,this.leftImgWidth, 'hoho')
		if (this.leftImgWidth != this.elementWidth) {
			// if(this._name == 'mobile') console.log(this,this.elementWidth,this.leftImgWidth)
			
			if (this.elementWidth == this.$leftImg[0].naturalWidth) {
				this.$leftImg.width('');
				this.$rightImg.width('');
			} else {
				this.$leftImg.width(this.elementWidth);
				this.$rightImg.width(this.elementWidth);
			}

		}

	}

	BeforeAfter.prototype.setPos = function(pos) {
		var _this = this;

		if (this.initialized) {
			this.$dragElement.css('left', pos + '%');
			this.$resizeLeftElement.css('width', pos + '%');
			this.$resizeRightElement.css('width', 100 - pos + '%');
		} else {
			setTimeout(function() {
				_this.$dragElement.css('left', pos + '%');
				_this.$resizeLeftElement.css('width', pos + '%');
				_this.$resizeRightElement.css('width', 100 - pos + '%');

				if (_this.options.defaultPos < 50) {

					if (this.options.rightToLeftCallback) {
						this.options.rightToLeftCallback();
					}
				}

				setTimeout(function() {
					_this.$element.addClass('initialized-and-animated');

					if (_this.options.initAnimFinished) {
						_this.options.initAnimFinished.call(_this.$element);
					}
				}, 800);
			}, 200);
		}
	}

	BeforeAfter.prototype.setCenterPos = function(pos) {
		if (this.overflowed) {
			this.centerPos = (bodyWidth - this.elementOffset) / 2 / this.elementWidth*100;
		} else {
			this.centerPos = 50;
		}
	}

	BeforeAfter.prototype.onMouseDown = function(e) {
		e.preventDefault();

		var _this = this;

		this.$element.addClass('ba-draggable');

		// Check if it's a mouse or touch event and pass along the correct value
		var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;
		this.posX = this.$dragElement.offset().left + this.dragElementWidth - startX;
		
		this.$element.on("mousemove.ba-events touchmove.ba-events", function(e) {
			_this.onMouseMove(e);
		});

		$document.on('mouseup.ba-events touchend.ba-events touchcancel.ba-events', function() {
			_this.onMouseUp();
		});
	}

	BeforeAfter.prototype.onMouseMove = function(e) {
		// var widthValuePerc;

		// Check if it's a mouse or touch event and pass along the correct value
		var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;

		this.leftValue = moveX + this.posX - this.dragElementWidth;

		// Prevent going off limits
		if (this.leftValue < this.minLeft) {
			this.leftValue = this.minLeft;
		} else if (this.leftValue > this.maxLeft) {
			this.leftValue = this.maxLeft;
		}
// console.log(this.elementWidth)
		// Translate the handle's left value to masked divs width.
		// this.widthValue = (this.leftValue + this.dragElementWidth/2 - this.elementOffset) * 100/this.elementWidth;
		this.widthValue = (this.leftValue - this.elementOffset) * 100/this.elementWidth;

		if (this.oldWidthValue <= this.centerPos && this.widthValue > this.centerPos) {

			if (this.options.leftToRightCallback) {
				this.options.leftToRightCallback();
			}

		} else if (this.oldWidthValue >= this.centerPos && this.widthValue < this.centerPos) {

			if (this.options.rightToLeftCallback) {
				this.options.rightToLeftCallback();
			}
		}

		this.oldWidthValue = this.widthValue;

		// Set the new values for the slider and the handle.
		this.setPos(this.widthValue);
		// this.$dragElement.css('left', widthValuePerc);
		// this.$resizeElement.css('width', widthValuePerc);
	}

	BeforeAfter.prototype.onMouseUp = function() {
		var _this = this;
		// Unbind all events for performance
		$document.off('.ba-events');
		this.$element.off('.ba-events');

		if (this.options.synchronized) {
			this.fullCollection.not('.ba-draggable').each(function() {
				var $this = $(this);
				$this.data('plugin_' + pluginName).synchronize(_this);
			});
		}

		this.$element.removeClass('ba-draggable');
	}

	BeforeAfter.prototype.synchronize = function(ethalon) {
		var curPos;

		if (ethalon.overflowed) {
			curPos = ethalon.widthValue / ethalon.centerPos * 50;
		} else {
			curPos = ethalon.widthValue;
		}

		if (this.overflowed) {
			this.widthValue = curPos * this.centerPos / 50;
		} else {
			this.widthValue = curPos;
		}

		this.setPos(this.widthValue);
		// widthValuePerc = this.widthValue + '%';
		// this.$dragElement.css('left', widthValuePerc);
		// this.$resizeElement.css('width', widthValuePerc);
		// console.log(curPos, ethalon.centerPos, ethalon.widthValue)
	}

	$.fn[pluginName] = function(options) {
		var fullCollection = this;
		this.each(function() {
			var $this = $(this);

			if (!$this.data('plugin_' + pluginName)) {
				$this.data('plugin_' + pluginName, new BeforeAfter(this, options, fullCollection));
			}

		});

		if (options.fullInitCallback) {
			options.fullInitCallback();
		}

		return this;
	}
})(jQuery, window, document);